export const productNameTransform = {
  "Vital Cover": "vitalCover",
  "Travel Master": "travelMaster",
  "Travel Lite": "travelLite",
  "Pet Care": "petCare",
  "Home Protect": "homeProtect",
  "Home Protect Lite": "homeProtectLite",
  AutoMaster: "autoMaster",
  "Moto One": "motoOne",
  CTPL: "ctpl",
  Golfers: "golfers",
};
